import DiscoveryFooter from '@design/components/footer/DiscoveryFooter/twig/assets'
import Newsletter from '@ui/Footer/Newsletter/component'

export default (el: HTMLElement) => {
  DiscoveryFooter(el)
  Newsletter(el)
}
